<template>
  <t-alert
    v-bind="alert"
    transition="scale-transition"
    @input="$emit('dismissed')"
    @mouseover.native="cancelExpiryTimer"
    @mouseout="startExpiryTimer"
  >
    {{ alert.message }}
    <template v-if="alert.action">
      <button @click="$emit('action')">
        <span class="t-font-bold hover:t-underline">{{ alert.action.text }}</span>
      </button>
    </template>
  </t-alert>
</template>

<script>
import { TAlert } from '@teamwork/ui-kit';
import { onMounted } from 'vue-demi';

export default {
  components: {
    TAlert,
  },
  props: {
    alert: {
      required: true,
      type: Object,
    },
  },
  setup(props, { emit }) {
    let expiryTimerId;
    function startExpiryTimer() {
      if (!props.alert.isPersistent) {
        expiryTimerId = setTimeout(() => {
          emit('expired');
        }, props.alert.duration);
      }
    }
    function cancelExpiryTimer() {
      clearTimeout(expiryTimerId);
    }
    onMounted(() => {
      startExpiryTimer();
    });
    return {
      cancelExpiryTimer,
      startExpiryTimer,
    };
  },
};
</script>

<style scoped></style>
